<template>
  <div
    :class="[
      'v-input',
      'v-input--hide-details',
      'v-input--is-label-active',
      'theme--light',
      'v-text-field',
      'v-text-field--enclosed',
      'v-text-field--outlined',
      'v-text-field--placeholder',
      {'primary--text': focused}
    ]"
  >
    <div class="v-input__control">
      <div class="v-text-field__slot">
        <label
          for="files-participants"
          class=""
          :class="[
            'v-label',
            'v-label--active',
            'theme--light',
            {'primary--text': focused}
          ]"
        >
          <slot></slot>
        </label>
        <slot name="input"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PersistentInputLabel',

    props: {
      focused: {
        type: Boolean,
        default: false
      }
    }
  };
</script>

<style scoped>
  label {
    left: 0;
    right: auto;
    position: absolute;
    display: inline-block;
    background: #fff;
    padding: 0 4px;
    margin-left: 8px;
    z-index: 1;
  }
</style>
